import { getConfiguration } from "./configuration";

export function isEntityToBeHiddenByDesc(desc) {
	let toHide = false;
	if (desc != null) {
		const entityRules = getConfiguration().eruls;
		if (entityRules != null) {
			const map = entityRules.hifcon;
			if (map != null) {
				for (let k in map) {
					const value = map[k];
					toHide = toHide || desc.toUpperCase().indexOf(value.toUpperCase()) >= 0;
				}
			}
		}
	}
	
	return toHide;
}
